// Meta Pixel helper — handles script injection, PageView tracking, and exposes
// a typed trackEvent() helper that buffers events until the pixel is ready.

const PIXEL_ID = '941894498720185'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Inject the Meta Pixel base script and fire the initial PageView.
 * Safe to call multiple times — will only initialize once.
 */
export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (initialized || window.fbq) {
    initialized = true
    return
  }
  initialized = true

  // Standard Meta Pixel base code
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode?.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  // Noscript fallback pixel
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

/**
 * Track a standard Meta Pixel event. Queues automatically if the pixel
 * is not yet loaded.
 */
export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window === 'undefined') return
  if (!window.fbq) {
    // Initialize on the fly if the call somehow lands before init.
    initMetaPixel()
  }
  try {
    if (params) {
      window.fbq('track', eventName, params)
    } else {
      window.fbq('track', eventName)
    }
  } catch (e) {
    // Silently ignore — we never want analytics to break the UX.
  }
}
